module.exports = __webpack_public_path__ + "img/fail.8cba4dc7.png";